<!-- 新建/编辑Banner管理 -->
<template>
  <el-main>
    <div class="tableList">
      <div class="tableContent" :style="{padding:'10px 15px'}">
        <!-- 上传图片 -->
        <div class="cropper-app">
          <el-form :model="formValidate" :rules="ruleValidate" ref="formValidate" class="demo-ruleForm">
            <el-form-item label="图片设置" prop="mainImage">
              <div class="list-img-box" :style="{display:'flex',flexDirection:'row'}">
                <div :style="{width:'413px',height:'220px'}" class="upload-btn" @click="uploadPicture('flagImg')">
                  <i class="el-icon-plus" style="font-size: 30px;"></i><span>图片设置</span>
                </div>
                <img v-if="formValidate.mainImage" :src="formValidate.mainImage" :style="{width:'413px',height:'220px',marginLeft:'10px'}"  alt="自定义图片">
              </div>
              <input type="hidden" v-model="formValidate.mainImage" placeholder="请添加图片">
            </el-form-item>
            <el-for-item>
              <template>
                <el-radio v-model="formValidate.type" label="1">文本</el-radio>
                <el-radio v-model="formValidate.type" label="2">网址</el-radio>
                <el-radio v-model="formValidate.type" label="3">房源</el-radio>
                <el-radio v-model="formValidate.type" label="4">列表</el-radio>
              </template>
            </el-for-item>
            <el-form-item label="正文" prop="content" :style="{marginBottom:'0px'}" v-if="formValidate.type == 1"></el-form-item>
            <div class="edit_container" :style="{width:'100%',height:'370px'}" v-if="formValidate.type == 1">
              <!-- 图片上传组件辅助，组件内添加v-show=“false”属性，把该组件隐藏起来。-->
              <el-upload class="avatar-uploader" :action="uploadUrl" name="file" :show-file-list="false" :on-success="uploadSuccess" :before-upload="beforeUpload">
              </el-upload>
              <!--新增时输入-->
              <quill-editor v-model="formValidate.content" :content="formValidate.content" ref="myQuillEditor" :options="editorOption"
                            @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @ready="onEditorReady($event)"
                            :style="{width:'100%',height:'300px'}"></quill-editor>

            </div>
            <el-form-item label="网址" prop="url" :style="{marginBottom:'0px',position:'relative'}" v-if="formValidate.type == 2">
              <div style="position: absolute;left: 0; top: 20px; z-index:999; font-size: 12px; color: gray;">请确认域名是否已配置到小程序平台业务域名，配置地址：微信小程序平台 -> 开发 -> 开发管理</div>
              <el-input v-model="formValidate.url" placeholder="请输入网址" style="margin-top: 20px"></el-input>
            </el-form-item>
            <el-form-item label="房源编号" prop="url" :style="{marginBottom:'0px'}" v-if="formValidate.type == 3">
              <el-input v-model="formValidate.url" placeholder="请输入房源编号"></el-input>
            </el-form-item>
            <el-form-item label="房源编号" prop="url" :style="{marginBottom:'0px'}" v-if="formValidate.type == 4">
              <el-input v-model="formValidate.url" placeholder="请输入房源编号，多个房源用,隔开"></el-input>
            </el-form-item>
          </el-form>
          <!-- 剪裁组件弹窗 -->
          <el-dialog title="裁切图片" :visible.sync="cropperModel" width="1110px" center :close-on-click-modal="false" :before-close="handleClose">
            <cropper-image :Name="cropperName" :cropperType="1" @uploadImgSuccess="handleUploadSuccess" ref="child"></cropper-image>
          </el-dialog>
          <!--查看大封面-->
          <el-dialog title="查看大图片" :visible.sync="imgVisible" center>
            <img :src="imgName" v-if="imgVisible" style="width: 100%" alt="查看">
          </el-dialog>
        </div>
        <!-- 保存 -->
        <div :style="{textAlign:'center',marginTop:formValidate.type == 1?'40px':'20px'}">
          <el-button  size="medium" type="primary" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor, width:'150px'}" @click="onConfirm">保存</el-button>
          <el-button  size="medium" :style="{width:'150px'}" @click="onCancel">取消</el-button>
        </div>
      </div>
    </div>
  </el-main>
</template>

<script>
  import CropperImage from "../Dialog/CropperImage";
  import { quillEditor } from "vue-quill-editor"; //调用编辑器
  import 'quill/dist/quill.core.css';
  import 'quill/dist/quill.snow.css';
  import 'quill/dist/quill.bubble.css';
  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],    //加粗，斜体，下划线，删除线
    ['blockquote', 'code-block'],     //引用，代码块
    [{ 'header': 1 }, { 'header': 2 }],        // 标题，键值对的形式；1、2表示字体大小
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],     //列表
    [{ 'script': 'sub'}, { 'script': 'super' }],   // 上下标
    [{ 'indent': '-1'}, { 'indent': '+1' }],     // 缩进
    [{ 'direction': 'rtl' }],             // 文本方向
    [{ 'size': ['small', false, 'large', 'huge'] }], // 字体大小
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],     //几级标题
    [{ 'color': [] }, { 'background': [] }],     // 字体颜色，字体背景颜色
    [{ 'font': [] }],     //字体
    [{ 'align': [] }],    //对齐方式
    ['clean'],    //清除字体样式
    ['image','video']    //上传图片、上传视频
  ];

  export default {
    name: 'BannerManagementOperation',
    components: {
      CropperImage,
      quillEditor
    },
    data () {
      return {
        formValidate: {
          mainImage: '',//添加图片
          mainImageSrc: '',//回显图片
          content: "",//文本编辑器内容
          type:"1", // 1.文本 2.网址
          url:"", // 网址
        },
        ruleValidate: { //图片非空验证
          mainImage: [
            { required: true, message: '请上传图片', trigger: 'blur'}
          ],
        },
        cropperModel:false,//裁切图片参数弹出框
        cropperName:"",//裁切图片参数图片名称
        imgName: "",//裁切图片参数查看大图src
        imgVisible: false,//裁切图片参数是否查看大图
        editorOption: {
          placeholder: "请在这里输入",
          theme: 'snow', //主题 snow/bubble
          modules:{
            history: {
              delay: 1000,
              maxStack: 50,
              userOnly: false
            },
            toolbar: {
              container: toolbarOptions,
              handlers: {
                image: function (value) {
                  if (value) {
                    // 调用element的图片上传组件
                    document.querySelector('.avatar-uploader input').click()
                  } else {
                    this.quill.format('image', false)
                  }
                }
              },
            }
          }
        },
        uploadUrl:"/api/file/upload",
      }
    },
    computed: {
      editor() {
        return this.$refs.myQuillEditor.quill;
      },
    },
    methods: {
      //图片设置
      uploadPicture(name){
        this.cropperName = name;
        this.cropperModel = true;
      },
      //图片上传成功后
      handleUploadSuccess (data){
        this.formValidate.mainImageSrc = data[0].path;
        this.formValidate.mainImage = api_url+"/"+data[0].path;
        this.handleClose();
      },
      // 关闭上传弹出框
      handleClose() {
        this.cropperModel = false;
        this.$refs.child.beClose();
      },
      // 转码
      escapeStringHTML(str) {
        str = str.replace(/&lt;/g,'<');
        str = str.replace(/&gt;/g,'>');
        return str;
      },
      // 失去焦点事件
      onEditorBlur(quill) {
        console.log('editor blur!', quill)
      },
      // 获得焦点事件
      onEditorFocus(quill) {
        console.log('editor focus!', quill)
      },
      // 准备富文本编辑器
      onEditorReady(quill) {
        console.log('editor ready!', quill)
      },
      // 内容改变事件
      onEditorChange({ quill, html, text }) {
        console.log('editor change!', quill, html, text)
        this.content = html
      },
      beforeUpload (file) { },
      uploadSuccess (res) {
        // 获取富文本组件实例
        let quill = this.$refs.myQuillEditor.quill
        // 如果上传成功
        if (res.status === 200) {
          // 获取光标所在位置
          let length = quill.getSelection().index;
          // 插入图片，res为服务器返回的图片链接地址
          console.log(res.data[0].path)
          quill.insertEmbed(length, 'image', api_url+"/"+res.data[0].path)
          // 调整光标到最后
          quill.setSelection(length + 1)
        } else {
          // 提示信息，需引入Message
          this.$message.error('图片插入失败！')
        }
      },

      // 提交上传
      onConfirm() {
        this.$refs['formValidate'].validate( (valid) => {
          if (valid) {
            let params = {},title="新增";
            if (this.formValidate.url.indexOf("，")!=-1){
              this.formValidate.url = this.formValidate.url.replace(/，/ig,',');
            }
            if (this.$route.query.data == undefined){
              params = {
                content:this.formValidate.type == 1?this.formValidate.content:'',
                url:this.formValidate.type == 2 || this.formValidate.type == 3 || this.formValidate.type == 4?this.formValidate.url:'',
                img:this.formValidate.mainImageSrc,
                type:this.formValidate.type,
                orderinfo:this.$route.query.orderinfo,
                status:1
              }
            } else {
              params = {
                id:this.$route.query.data.id,
                url:this.formValidate.type == 2 || this.formValidate.type == 3 || this.formValidate.type == 4?this.formValidate.url:'',
                content:this.formValidate.content,
                type:this.formValidate.type,
                img:this.formValidate.mainImageSrc == ''?this.$route.query.data.img:this.formValidate.mainImageSrc,
                status:1
              }
              title = "编辑";
            }
            this.$api.saveOrUpdateBanner({parameter: JSON.stringify(params)}).then(res => {
              if (res.data.status == 200) {
                this.$message({
                  type: 'success',
                  message: title+'成功！'
                });
                this.$router.push('/BannerManagement');
              } else {
                this.$message({
                  type: 'error',
                  message: res.data.message
                });
              }
            });
          }
        })
      },
      //返回上一页
      onCancel(){
        this.$router.push('/BannerManagement');
      },
    },
    mounted(){
      if (this.$route.query.data != undefined){
        this.formValidate.content = this.escapeStringHTML(this.$route.query.data.content);
        this.formValidate.url = this.$route.query.data.url,
          this.formValidate.type = this.$route.query.data.type.toString(),
          this.formValidate.mainImage = api_url+"/"+this.$route.query.data.img;
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/css/detaileds.css";/* 列表样式 */
</style>





// WEBPACK FOOTER //
// src/components/Menu/BannerManagementOperation.vue